import { Server } from "@wajeez/wajeez.microservices";
import ChangePasswordForm from "./ChangePasswordForm";
import SetPasswordForm from "./SetPasswordForm";
import TranslatedText from "@components/items/display/TranslatedText";

const ChangePasswordRow = ({ user }: { user: Server.AuthenticateOutput }) => {
  return (
    <div className="grid w-full grid-cols-3 items-center py-5">
      <TranslatedText
        text={`settings.titles.${"password"}`}
        className="text-black dark:text-white"
      />
      {user.hasPassword ? (
        <ChangePasswordForm />
      ) : (
        <SetPasswordForm userEmail={user.email ?? ""} />
      )}
    </div>
  );
};

export default ChangePasswordRow;
